module.exports = __webpack_public_path__ + "img/care-1.6f618090.jpg";